// src/utils/formatDate.js
import moment from 'moment-timezone';

export const formatDateconvert = (dateString) => {
  return moment.tz(dateString, 'UTC').format('DD MMM YYYY');
};
// export const formatDate = (timestamp) => {
//   return moment.utc(timestamp).format('MMM DD');
// };
// export const formatTimeInTimezone = (timestamp) => {
//   const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//   return moment.utc(timestamp).tz(userTimezone).format('hh:mm A');
// };
export const formatDate = (date) => {
  if (!date) return "N/A";

  const m = moment.utc(date);
  return m.isValid() ? m.local().format("MMM DD") : "N/A";
};

export const formatTimeInTimezone = (date) => {
  if (!date) return "N/A";

  const m = moment.utc(date);
  return m.isValid() ? m.local().format("hh:mm A") : "N/A";
};

export const formatDateUTC = (date) => {
  if (!date) return "N/A";

  const m = moment.utc(date);
  return m.isValid() ? m.format("DD/MM/YYYY") : "N/A";
};

